import springCenfApi from '../../services/springCenfApi'

export const getInvoices = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/invoices', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)